import React, { useState, useEffect, useContext } from 'react';
import MenuItem from '../Component/MenuItem';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { getMenuLevel1 } from '../services/menuList';
import { UserContext } from '../UserContext';

const Menu = ({ menuData }) => {
  const { operatorCode } = useContext(UserContext);
  const [expandedItem, setExpandedItem] = useState(null);
  const [result, setResult] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const urlPath = location.pathname.substring(1).split("/");
  const decodedUrlPath = urlPath.map(decodeURIComponent);
  // Loaded once (shared with the header and home page), not on every page change.
  useEffect(() => {
    const fetchData = async () => {
      try {
        const fetchedResult = await getMenuLevel1(sessionStorage.getItem('appName'), operatorCode);
        setResult(Array.isArray(fetchedResult) ? fetchedResult : []);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, [menuData, operatorCode]);

  useEffect(() => {
    if (decodedUrlPath.length === 1 || decodedUrlPath.length === 2) {
      setExpandedItem(decodedUrlPath[0]);

    }
    else if (decodedUrlPath.length === 4) {
      setExpandedItem(decodedUrlPath[1]);

    }
    else if (decodedUrlPath[1]) {
      setExpandedItem(decodedUrlPath[1]);
    }
  }, [decodedUrlPath, menuData]);

  const handleItemClick = (item) => {
    navigate(`${item}`);
    setExpandedItem(item);
  };


  return (
    <aside id="sidebar" className="sidebar">
      <ul className="sidebar-nav" id="sidebar-nav">
        {result.map((item, index) => (
          <MenuItem
            key={index}
            item={item.col1}
            onClick={() => handleItemClick(item.col1)}
            isActive={expandedItem === item.col1}
          />
        ))}
      </ul>
    </aside>
  );
};

export default Menu;
